import React, { Component } from 'react';
import { Tag } from 'antd';
import { Link } from 'react-router-dom';
import styles from './style.less';

export default class SingleCompetition extends Component {
  getTagColor = (tag) => {
    // 按文字哈希取固定浅色 GIS 配色，稳定不闪烁
    const palette = [
      { bg: '#e3f0fb', color: '#2f7fc4' },
      { bg: '#e0f5f2', color: '#1f9d8f' },
      { bg: '#f2ecfa', color: '#7b5fc9' },
      { bg: '#fdf0e4', color: '#c07a2f' },
      { bg: '#e8f3e4', color: '#4f9440' },
    ];
    let hash = 0;
    for (let i = 0; i < tag.length; i++) hash = (hash * 31 + tag.charCodeAt(i)) >>> 0;
    return palette[hash % palette.length];
  };

  componentDidMount() {}

  // 当前登录用户是否为管理员
  isAdmin = () => {
    try {
      const u = JSON.parse(window.localStorage.getItem('user') || '{}');
      return u.role === 'admin';
    } catch (e) {
      return false;
    }
  };

  // 官网公开模式：纵向宽松卡片
  renderPublicCard() {
    const { desc, organizer, end_time, status, tags, title, team_num, _id } =
      this.props.competition;
    const statusMap = {
      0: { text: '未开始', cls: styles['p-before'] },
      1: { text: '进行中', cls: styles['p-in'] },
      2: { text: '已结束', cls: styles['p-after'] },
    };
    const s = statusMap[status] || statusMap[0];

    return (
      <Link
        to={`/portal/game-detail/${_id}`}
        className={styles['p-card-link']}
      >
        <div className={styles['p-card']}>
          <div className={styles['p-head']}>
            <h3 className={styles['p-title']}>{title}</h3>
            <span className={`${styles['p-status']} ${s.cls}`}>{s.text}</span>
          </div>

          {(tags || []).length > 0 && (
            <div className={styles['p-tags']}>
              {(tags || []).map((tag, index) => {
                const c = this.getTagColor(tag);
                return (
                  <Tag
                    color={c.bg}
                    style={{
                      color: c.color,
                      border: 'none',
                      borderRadius: '10px',
                      fontWeight: 500,
                      padding: '1px 10px',
                      marginRight: 8,
                    }}
                    key={index}
                  >
                    {tag}
                  </Tag>
                );
              })}
            </div>
          )}

          <p className={styles['p-desc']}>{desc}</p>

          <div className={styles['p-meta']}>
            <div className={styles['p-meta-item']}>
              <span className={styles['p-meta-key']}>已报名</span>
              <span className={styles['p-meta-value']}>{team_num || 0} 支</span>
            </div>
            <div className={styles['p-meta-item']}>
              <span className={styles['p-meta-key']}>报名截止</span>
              <span className={styles['p-meta-value']}>{end_time}</span>
            </div>
          </div>

          <div className={styles['p-footer']}>
            <span>主办方：{organizer}</span>
            <span className={styles['p-more']}>查看详情 →</span>
          </div>
        </div>
      </Link>
    );
  }

  render() {
    if (this.props.publicMode) {
      return this.renderPublicCard();
    }

    let {
      content,
      desc,
      organizer,
      start_time,
      end_time,
      status,
      tags,
      title,
      team_num,
      _id,
    } = this.props.competition;
    // const startTime = start_time.slice(0, start_time.indexOf('T'));
    return (
      <Link to={`/home/game-detail/${_id}/rule`} className={styles['container-link']}>
        <div className={styles['container']}>
        <div className={styles['header']}>
          <span style={{ font: "400 22px 'Gotham'", color: '#1e3247' }} className={styles['title']}>
            {title}
          </span>
          {(tags || []).map((tag, index) => {
            const c = this.getTagColor(tag);
            return (
              <Tag
                color={c.bg}
                style={{
                  display: 'inline-block',
                  position: 'relative',
                  left: '15px',
                  top: '-4px',
                  borderRadius: '10px',
                  color: c.color,
                  border: 'none',
                  fontWeight: 500,
                  letterSpacing: '1px',
                  padding: '1px 10px',
                }}
                key={index}
              >
                {tag}
              </Tag>
            );
          })}
        </div>
        <div className={styles['main']}>
          <div className={styles['desc']}>{desc}</div>
          <div className={styles['teams']}>
            <p className={styles['key']}>团队</p>
            <p className={styles['value']}>{team_num}</p>
          </div>
          <div className={styles['time']}>
            <p className={styles['key']}>报名截止</p>
            <p className={styles['value']}>{end_time}</p>
          </div>
          <div
            className={`${styles['status']} ${
              status == 0
                ? styles['before-status']
                : status == 1
                ? styles['in-status']
                : styles['after-status']
            }`}
          >
            <span>
              {status == 0 ? '未开始' : status == 1 ? '进行中' : '已结束'}
            </span>
          </div>
        </div>
        <div className={styles['footer']}>
          <span>举办方:{organizer}</span>
        </div>
        {this.isAdmin() && this.props.onAdjustDeadline && (
          <span
            className={styles['deadline-edit']}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.props.onAdjustDeadline(this.props.competition);
            }}
          >
            ⚙ 调整报名时间
          </span>
        )}
        </div>
      </Link>
    );
  }
}
